import { useState } from 'react';

import changePasswordSVG from '../img/change-password.svg';
import disableSVG from '../img/disable.svg';
import editSVG from '../img/edit.svg';
import informationsSVG from '../img/informations.svg';
import agentSVG from '../img/agent.svg';
import playerSVG from '../img/player.svg';
import moreToLessSVG from '../img/moreToLess.svg';
import lessToMoreSVG from '../img/lessToMore.svg';
import playerHistorySVG from '../img/playerHistory.svg';
import depositHistorySVG from '../img/depositHistory.svg';
import changePermissionsSVG from '../img/change-permissions.svg';
import activateCashbackSVG from '../img/activate-cashback.svg';
import cashbackTermsSVG from '../img/cashback-terms.svg';

export const amountTypes = { 500: false, 1000: false, 2500: false, 5000: false, 10000: false };

export const useAmountTypes = () => {
  const [types, setType] = useState(amountTypes);

  return { types, setType };
};

export const parseBalance = balance => {
  const cleanedBalance = balance.replace('.', '');
  const splittedBalance = cleanedBalance.split(',');
  const countedBalance = !!(splittedBalance[0] % 1) ? splittedBalance[0] * 1000 : splittedBalance[0];
  const hasDecimalPart = splittedBalance.length > 1;
  return hasDecimalPart ? `${countedBalance}.${splittedBalance[1]}` : countedBalance;
};

export const balanceSortTypes = [
  {
    value: '-balance',
    name: 'moreToLess',
    svg: moreToLessSVG,
  },
  {
    value: '+balance',
    name: 'lessToMore',
    svg: lessToMoreSVG,
  },
  {
    value: '-total_deposits',
    name: 'status',
    isMobile: true,
  },
  {
    value: 0,
    name: 'none',
  },
];

export const usernameSortTypes = [
  {
    value: '-nickname',
    name: 'zToa',
    svg: moreToLessSVG,
  },
  {
    value: '+nickname',
    name: 'aToz',
    svg: lessToMoreSVG,
  },
  {
    value: '-total_deposits',
    name: 'status',
  },
  {
    value: 0,
    name: 'none',
  },
];

export const userTypes = {
  0: {
    icon: playerSVG,
    type: 'player',
  },
  6: {
    icon: agentSVG,
    type: 'agent',
  },
};

export const actionItems = {
  forEnabled: [
    {
      svg: informationsSVG,
      title: 'informations',
      link: '/user/info',
    },
    {
      svg: editSVG,
      title: 'edit',
      link: '/user/edit',
    },
    {
      svg: changePasswordSVG,
      title: 'changePassword',
      link: '/user/change-password',
    },
    {
      svg: disableSVG,
      title: 'disable',
      link: '/user/disable',
    },
    {
      svg: changePermissionsSVG,
      title: 'changePermissions',
    },
  ],
  forDisabled: [
    {
      svg: disableSVG,
      title: 'enable',
      link: '/user/enable',
    },
  ],
};

export const getActionItems = ({ role, isBanned, item, isCashbackActive }) => {
  if (isBanned) {
    return [
      {
        svg: disableSVG,
        title: 'enable',
        link: '/user/enable',
      },
    ];
  }
  if (+role === 0) {
    return [
      {
        svg: informationsSVG,
        title: 'informations',
        link: '/user/info',
      },
      {
        svg: editSVG,
        title: 'edit',
        link: '/user/edit',
      },
      {
        svg: changePasswordSVG,
        title: 'changePassword',
        link: '/user/change-password',
      },
      {
        svg: changePermissionsSVG,
        title: 'permissionsDetails',
        link: '/user/permissionsDetails',
      },
      {
        svg: playerHistorySVG,
        title: 'playerHistory',
        link: `/reports/player-reports/player-history?username=${item?.username}`,
        withoutId: true,
      },
      {
        svg: depositHistorySVG,
        title: 'deposits',
        link: `/reports/financial-reports/cash?username=${item?.username}&role=${role}`,
        withoutId: true,
      },
      {
        svg: activateCashbackSVG,
        title: 'activateCashback',
        withCallback: true,
        withSwitcher: true,
        checkForActiveCashback: true,
      },
      {
        svg: cashbackTermsSVG,
        title: 'cashbackTerms',
        withCallback: true,
        checkForActiveCashback: true,
      },
      {
        svg: disableSVG,
        title: 'disable',
        link: '/user/disable',
      },
    ].filter(item => !item.checkForActiveCashback || isCashbackActive);
  }
  if (+role === 6) {
    return [
      {
        svg: informationsSVG,
        title: 'informations',
        link: '/user/info',
      },
      {
        svg: editSVG,
        title: 'edit',
        link: '/user/edit',
      },
      {
        svg: changePasswordSVG,
        title: 'changePassword',
        link: '/user/change-password',
      },
      {
        svg: changePermissionsSVG,
        title: 'permissionsDetails',
        link: '/user/permissionsDetails',
      },
      {
        svg: depositHistorySVG,
        title: 'deposits',
        link: `/reports/financial-reports/cash?username=${item?.username}&role=${role}`,
        withoutId: true,
      },
      {
        svg: activateCashbackSVG,
        title: 'activateCashback',
        withCallback: true,
        withSwitcher: true,
        checkForActiveCashback: true,
      },
      {
        svg: cashbackTermsSVG,
        title: 'cashbackTerms',
        withCallback: true,
        checkForActiveCashback: true,
      },
      {
        svg: disableSVG,
        title: 'disable',
        link: '/user/disable',
      },
    ].filter(item => !item.checkForActiveCashback || isCashbackActive);
  }
};

export const permissionsDetailsData = [
  {
    category: 'casino',
    items: [
      'rubiplay',
      'pragmatic',
      'outcome',
      'slotegrator',
      'universalRace',
      'evoplay',
      'belatra',
      'redrake',
      'platipus',
      'upgaming',
      'bgaming',
      'betOnGames',
      'hacksaw',
      'amigogaming',
      '100hp',
      'amusnet',
      'winfinity',
      'kagaming',
      'bluejack',
    ],
  },
  {
    category: 'virtualGames',
    items: ['goldenRace'],
  },
  {
    category: 'liveCasino',
    items: ['xpg', 'pragmaticlive', 'tvbet', 'ezugi', 'popokgaming', 'vivogaming', 'jacktop', 'winfinityLive'],
  },
  { category: 'sport', items: ['Digitain', 'gr8'] },
];

export const providerNameReplaceMap = {
  pragmatic: 'pragmatic-full',
};

export const isProviderBlocked = (bannedProviders, provider) => {
  switch (provider) {
    case 'pragmatic':
      if (bannedProviders.includes('pragmatic-full')) return true;
      if (bannedProviders.includes('pragmatic') && bannedProviders.includes('pragmatic-rgs')) return true;
      return false;

    default:
      return bannedProviders.includes(provider);
  }
};
